import React from 'react';

export default function Footer() {
  // Logo locale Smart Info (stesso usato nel navbar, trasparente)
  const smartInfoLogo = "/assets/smart_info_logo.png";
  const federpolBadge = "https://static.wixstatic.com/media/b65349_561c901f282b46e38aae568c4f463897~mv2.avif/v1/fill/w_56,h_57,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Logo-FEDERPOL.avif";
  const wadBadge = "https://static.wixstatic.com/media/b65349_8b79c9cc3a9a4d8f9cc9bda51bbe1504~mv2.webp/v1/fill/w_56,h_57,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/WAD.webp";
  const onissfBadge = "https://static.wixstatic.com/media/b65349_5d79c6b5841944e78c051cfec4495bf4~mv2.jpg/v1/fill/w_57,h_57,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/ONISSF_logo%201.jpg";

  return (
    <>
      <style>
        {`
          .footer-smartinfo {
            font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
          }
        `}
      </style>
      
      <footer className="footer-smartinfo" data-testid="footer">
        
        {/* ========== BARRA SOCIAL ========== */}
        <div className="bg-[#0a0a0a] border-t border-[#D4AF37]/20 py-5">
          <div className="max-w-[980px] mx-auto px-4">
            <div className="flex justify-between items-center">
              {/* LinkedIn */}
              <a 
                href="https://www.linkedin.com/company/smart-info-srl" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#E5E5E5] hover:text-[#D4AF37] transition-colors"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
                <span className="text-[15px] font-normal">Linkedin</span>
              </a>
              
              {/* Facebook */}
              <a 
                href="https://www.facebook.com/smartinfosrl" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#E5E5E5] hover:text-[#D4AF37] transition-colors"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
                <span className="text-[15px] font-normal">Facebook</span>
              </a>
              
              {/* TikTok */}
              <a 
                href="https://www.tiktok.com/@smartinfosrl" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#E5E5E5] hover:text-[#D4AF37] transition-colors"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                </svg>
                <span className="text-[15px] font-normal">Tik Tok</span>
              </a>
              
              {/* Instagram */}
              <a 
                href="https://www.instagram.com/smartinfosrl" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-[#E5E5E5] hover:text-[#D4AF37] transition-colors"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
                <span className="text-[15px] font-normal">Instagram</span>
              </a>
            </div>
          </div>
        </div>

        {/* ========== FOOTER PRINCIPALE ========== */}
        <div className="bg-[#050505] py-14">
          <div className="max-w-[980px] mx-auto px-4">
            <div className="grid grid-cols-4">
              
              {/* Colonna 1 - Logo & Badge */}
              <div className="pr-8">
                <div className="mb-6">
                  <a href="https://www.smart-info.it" target="_blank" rel="noopener noreferrer">
                    <img 
                      src={smartInfoLogo} 
                      alt="Smart Info - Agenzia Investigativa" 
                      className="h-[45px] w-auto"
                    />
                  </a>
                </div>
                <div className="flex items-center gap-1.5">
                  <img src={federpolBadge} alt="Federpol" className="w-[52px] h-[52px] rounded-full" />
                  <img src={wadBadge} alt="WAD" className="w-[52px] h-[52px] rounded-full" />
                  <img src={onissfBadge} alt="ONISSF" className="w-[52px] h-[52px] rounded-full" />
                </div>
              </div>

              {/* Colonna 2 - Contatti */}
              <div className="px-4">
                <h4 className="text-[#D4AF37] text-[12px] font-semibold mb-6 uppercase tracking-[0.2em]">Contatti</h4>
                <div className="space-y-1 text-[#A3A3A3] text-[14px] font-normal leading-relaxed">
                  <p>Via V. Veneto, 169</p>
                  <p>Roma, RM 00187</p>
                  <p className="pt-5">
                    <a href="mailto:info@smart-info.it" className="text-[#E5E5E5] hover:text-[#D4AF37] transition-colors">
                      info@smart-info.it
                    </a>
                  </p>
                  <p>
                    <a href="mailto:smartinfosrl2@legalmail.it" className="text-[#E5E5E5] hover:text-[#D4AF37] transition-colors">
                      smartinfosrl2@legalmail.it
                    </a>
                  </p>
                </div>
              </div>

              {/* Colonna 3 - Link */}
              <div className="px-4">
                <h4 className="text-[#D4AF37] text-[12px] font-semibold mb-6 uppercase tracking-[0.2em]">Link</h4>
                <ul className="space-y-2 text-[#A3A3A3] text-[14px] font-normal">
                  <li><a href="https://www.smart-info.it" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors">Home</a></li>
                  <li><a href="https://www.smart-info.it/chi-siamo" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors">Chi Siamo</a></li>
                  <li><a href="https://www.smart-info.it/contatti" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors">Contatti</a></li>
                  <li><a href="https://www.smart-info.it/lavora-con-noi" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors">Lavora con noi</a></li>
                  <li><a href="https://www.smart-info.it/informativa-privacy" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors">Privacy</a></li>
                </ul>
              </div>

              {/* Colonna 4 - Servizi */}
              <div className="pl-4">
                <h4 className="text-[#D4AF37] text-[12px] font-semibold mb-6 uppercase tracking-[0.2em]">Servizi</h4>
                <ul className="space-y-2 text-[#A3A3A3] text-[14px] font-normal">
                  <li><a href="https://www.smart-info.it/informazioni-commerciali" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors">Informazioni Commerciali</a></li>
                  <li><a href="https://www.smart-info.it/investigazioni" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors">Investigazioni</a></li>
                  <li><a href="https://www.smart-info.it/cyber-security" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors">Cyber Security</a></li>
                  <li><a href="https://www.smart-info.it/bonifiche-ambientali" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors">Bonifiche Ambientali</a></li>
                  <li><a href="https://www.smart-info.it/news" target="_blank" rel="noopener noreferrer" className="hover:text-[#D4AF37] transition-colors">News & Aggiornamenti</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* ========== COPYRIGHT ========== */}
        <div className="bg-[#050505] border-t border-[#1f2937] py-5">
          <div className="max-w-[980px] mx-auto px-4">
            <p className="text-[12px] text-[#A3A3A3] font-normal">
              ©{new Date().getFullYear()} Smart Info s.r.l. - Tutti i Diritti Riservati - P.I.13124171003
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}
